import { useSearchParams } from 'react-router-dom';
import { NeedsApprovalCard } from '../components/work/MyApprovals';
import ServiceRequestBoard from '../components/work/ServiceRequestBoard';
import ServiceRequestList from '../components/work/ServiceRequestList';
import ServiceRequestShell from '../components/work/ServiceRequestShell';

export default function ServiceRequests() {
  const [searchParams] = useSearchParams();
  const isList = searchParams.get('layout') === 'list';

  return (
    <ServiceRequestShell active={isList ? 'list' : 'board'}>
      <NeedsApprovalCard />
      {isList ? <ServiceRequestList /> : <ServiceRequestBoard />}
    </ServiceRequestShell>
  );
}
